import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';


const FilterPanel = ({ filters, onFilterChange, onClearFilters }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const experienceLevels = [
    { value: 'fresher', label: 'Fresher (0-1 years)' },
    { value: 'junior', label: 'Junior (1-3 years)' },
    { value: 'mid', label: 'Mid-Level (3-5 years)' },
    { value: 'senior', label: 'Senior (5-8 years)' },
    { value: 'lead', label: 'Lead (8+ years)' }
  ];

  const statusOptions = [
    { value: 'new', label: 'New Application' },
    { value: 'screening', label: 'Under Screening' },
    { value: 'shortlisted', label: 'Shortlisted' },
    { value: 'interview_scheduled', label: 'Interview Scheduled' },
    { value: 'interviewed', label: 'Interviewed' },
    { value: 'offered', label: 'Offer Extended' },
    { value: 'hired', label: 'Hired' },
    { value: 'rejected', label: 'Rejected' }
  ];

  const locationOptions = [
    { value: 'mumbai', label: 'Mumbai' },
    { value: 'delhi', label: 'Delhi' },
    { value: 'bangalore', label: 'Bangalore' },
    { value: 'hyderabad', label: 'Hyderabad' },
    { value: 'pune', label: 'Pune' },
    { value: 'chennai', label: 'Chennai' },
    { value: 'kolkata', label: 'Kolkata' },
    { value: 'ahmedabad', label: 'Ahmedabad' }
  ];

  const skillMatchRanges = [
    { value: '90-100', label: '90-100% Match' },
    { value: '80-89', label: '80-89% Match' },
    { value: '70-79', label: '70-79% Match' },
    { value: '60-69', label: '60-69% Match' },
    { value: '0-59', label: 'Below 60% Match' }
  ];

  const hasActiveFilters = () => {
    return filters?.search || 
           filters?.experience?.length > 0 || 
           filters?.status?.length > 0 || 
           filters?.location?.length > 0 || 
           filters?.skillMatch || 
           filters?.minSalary || 
           filters?.maxSalary;
  };

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="text-base font-semibold text-foreground">Filters</h3>
          {hasActiveFilters() && (
            <span className="px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
              Active
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          {hasActiveFilters() && (
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              onClick={onClearFilters}
            >
              Clear
            </Button>
          )}
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="p-1 hover:bg-muted rounded transition-smooth"
          >
            <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={20} />
          </button>
        </div>
      </div>
      {isExpanded && (
        <div className="p-4 space-y-4">
          <Input
            type="search"
            placeholder="Search by name, email, or skills..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="w-full"
          />

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Experience Level
            </label>
            <Select
              placeholder="Select experience levels"
              options={experienceLevels}
              value={filters?.experience}
              onChange={(value) => onFilterChange('experience', value)}
              multiple
              searchable
              clearable
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Application Status
            </label>
            <Select
              placeholder="Select status"
              options={statusOptions}
              value={filters?.status}
              onChange={(value) => onFilterChange('status', value)}
              multiple
              searchable
              clearable
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Location
            </label>
            <Select
              placeholder="Select locations"
              options={locationOptions}
              value={filters?.location}
              onChange={(value) => onFilterChange('location', value)}
              multiple
              searchable
              clearable
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Skills Match
            </label>
            <Select
              placeholder="Select match range"
              options={skillMatchRanges}
              value={filters?.skillMatch}
              onChange={(value) => onFilterChange('skillMatch', value)}
              clearable
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Expected Salary Range (₹ LPA)
            </label>
            <div className="grid grid-cols-2 gap-3">
              <Input
                type="number"
                placeholder="Min"
                value={filters?.minSalary}
                onChange={(e) => onFilterChange('minSalary', e?.target?.value)}
              />
              <Input
                type="number"
                placeholder="Max"
                value={filters?.maxSalary}
                onChange={(e) => onFilterChange('maxSalary', e?.target?.value)}
              />
            </div>
          </div>

          <div className="pt-4 border-t border-border">
            <Button
              variant="default"
              fullWidth
              iconName="Search"
              iconPosition="left"
            >
              Apply Filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;